import { CreateUserIcon } from 'components/Icon'
import { Button, Flex } from 'theme-ui'

export type CreateTeacherBtnProps = {
  handleCreateTeacherClick: () => void
}

export function CreateTeacherBtn({
  handleCreateTeacherClick,
}: CreateTeacherBtnProps) {
  return (
    <Flex data-cy="create-teacher" sx={{ alignItems: 'center' }}>
      <Button
        id="create-teacher-mobile-btn"
        sx={{
          bg: 'white',
          width: 40,
          height: 40,
          px: 0,
          py: 0,
          mr: 2,
          borderRadius: '100%',
          display: ['inline-block', 'none'],
        }}
        disabled={!handleCreateTeacherClick}
        onClick={handleCreateTeacherClick}>
        <CreateUserIcon />
      </Button>
      <Button
        id="create-teacher-btn"
        variant="buttons.outlineWhite"
        sx={{
          px: [20, 20],
          py: [0, 0, 0],
          height: 50,
          m: 'auto',
          mr: 16,
          display: ['none', 'inline-block'],
          minWidth: 145,
        }}
        disabled={!handleCreateTeacherClick}
        onClick={handleCreateTeacherClick}>
        + Teacher
      </Button>
    </Flex>
  )
}
